import request from '@/api/request'
/**
 * 删除关系人
 */
export function relationDelApi (query) {
  return request({
    url: '/auth/relation/del',
    method: 'delete',
    params: query
  })
}

/**
 * 关系人列表
 */
export function relationListApi () {
  return request({
    url: '/auth/relation/list',
    method: 'get'
  })
}

/**
 * 关系人信息
 */
export function relationInfoApi (query) {
  return request({
    url: '/auth/relation/info',
    method: 'get',
    params: query
  })
}

/**
 * 保存关系人信息
 */
export function relationSaveApi (data) {
  return request({
    url: '/auth/relation/save',
    method: 'post',
    data
  })
}

/**
 * 保存关系人信息
 */
export function relationOCRApi (data) {
  return request({
    url: '/auth/relation/ocr',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/my/relation.js